var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 17,
    viewBox: "0 0 9 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.183617 16.0683C0.125413 16.0103 0.0792341 15.9413 0.047726 15.8654C0.016218 15.7894 -2.3775e-08 15.708 -2.73685e-08 15.6258C-3.09619e-08 15.5436 0.0162179 15.4622 0.047726 15.3863C0.079234 15.3104 0.125413 15.2414 0.183617 15.1833L7.24237 8.12584L0.183616 1.06834C0.125506 1.01023 0.0794109 0.94124 0.047962 0.865315C0.0165131 0.789392 0.00032655 0.708016 0.000326546 0.625836C0.000326543 0.543656 0.0165131 0.462281 0.047962 0.386356C0.0794108 0.310432 0.125506 0.241446 0.183616 0.183336C0.241726 0.125227 0.310712 0.0791302 0.386637 0.0476818C0.462561 0.0162334 0.543936 4.76599e-05 0.626116 4.76563e-05C0.708296 4.76528e-05 0.789671 0.0162334 0.865596 0.0476818C0.94152 0.0791301 1.01051 0.125227 1.06862 0.183336L8.56862 7.68334C8.62682 7.74139 8.673 7.81036 8.70451 7.88629C8.73601 7.96223 8.75223 8.04363 8.75223 8.12584C8.75223 8.20804 8.73601 8.28945 8.70451 8.36538C8.673 8.44131 8.62682 8.51028 8.56862 8.56834L1.06862 16.0683C1.01056 16.1265 0.94159 16.1727 0.865659 16.2042C0.789728 16.2357 0.708326 16.252 0.626117 16.252C0.543908 16.252 0.462506 16.2357 0.386575 16.2042C0.310643 16.1727 0.241674 16.1265 0.183617 16.0683Z",
    fill: "#00C8A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/ChevronRight.92684b14d085be0496f15d103d2d810d.svg";
export { ForwardRef as ReactComponent };